const activies = {
  path: '/nayang',
  redirect: '/nayang/index',
  component: () => import('@/layout'),
  children: [
    {
      path: 'index', // 频道页
      name: 'nayang',
      meta: { title: '频道页' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/nayang/index')
    },
    {
      // path: 'special/:code/active_code/:active_code/:id', // 专题页 ccc已配置的如何处理
      path: '/nayang/submit/:id', // 专题页
      name: 'nayangSubmit',
      meta: { title: '专题页' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/nayang/apply')
    }
  ]
}

export default activies
